import { render, staticRenderFns } from "./TheSitemap.vue?vue&type=template&id=53b7c818&scoped=true"
import script from "./TheSitemap.vue?vue&type=script&lang=js"
export * from "./TheSitemap.vue?vue&type=script&lang=js"
import style0 from "./TheSitemap.vue?vue&type=style&index=0&id=53b7c818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7c818",
  null
  
)

export default component.exports